import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.93,2.67V3.83l1.67.48V6.5L7.93,7V8.17l6.36-2V4.67Zm2.59,3.56V4.56l3,.83ZM7.93,10l.38.11a1.71,1.71,0,0,0-.52,1.26,1.79,1.79,0,0,0,.29,1,2.14,2.14,0,0,0,.82.73,2.59,2.59,0,0,0,1.1.24h.11a2.93,2.93,0,0,0,1.21-.23,1.79,1.79,0,0,0,.8-.64,1.82,1.82,0,0,0-.22-2.22h2.39V9.13H7.93ZM9,10.25h2a1.27,1.27,0,0,1,.38.45,1.29,1.29,0,0,1,.13.58c0,.62-.46.94-1.39.94H10a1.77,1.77,0,0,1-1-.28.91.91,0,0,1-.37-.76A1.23,1.23,0,0,1,9,10.25Zm-2.34.69a.75.75,0,0,1-.16.82L4.37,13.89a.75.75,0,0,1-1.06,0L1.18,11.76A.75.75,0,0,1,1,10.94a.74.74,0,0,1,.69-.46H3.09V2.67a.75.75,0,0,1,1.5,0v7.81H6A.74.74,0,0,1,6.66,10.94Z';
const draw24px =
  'M14.4,9.76V6.46l-2.5-.72V4l9.53,2.92V9.26L11.9,12.32V10.55Zm1.38-2.91v2.5l4.45-1.26Zm2.39,11.87a2.76,2.76,0,0,1-1.2,1,4.6,4.6,0,0,1-1.81.34h-.11a3.71,3.71,0,0,1-1.65-.37,3.06,3.06,0,0,1-1.24-1.09,2.74,2.74,0,0,1-.44-1.5,2.51,2.51,0,0,1,.79-1.89L11.9,15V13.7h9.53v1.69H17.84a2.48,2.48,0,0,1,.75,1.88A2.55,2.55,0,0,1,18.17,18.72Zm-3-.39c1.39,0,2.09-.47,2.09-1.41a2,2,0,0,0-.2-.87,2,2,0,0,0-.57-.66H13.59a1.84,1.84,0,0,0-.6,1.39,1.32,1.32,0,0,0,.55,1.13,2.55,2.55,0,0,0,1.57.42ZM9.64,16.57A.75.75,0,0,0,9,16.11H6.5V4A.75.75,0,0,0,5,4v12.1H2.56A.75.75,0,0,0,2,17.39l3.19,3.19a.79.79,0,0,0,.53.22.75.75,0,0,0,.53-.22l3.2-3.19A.78.78,0,0,0,9.64,16.57Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextOrientationVerticalDownIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'textOrientationVerticalDown')) as IconWithRender;

TextOrientationVerticalDownIcon.displayName = 'TextOrientationVerticalDownIcon';
TextOrientationVerticalDownIcon.propTypes = Icon.propTypes;
TextOrientationVerticalDownIcon.renderIcon = (props) => (
  <TextOrientationVerticalDownIcon {...props} />
);
export default TextOrientationVerticalDownIcon;
